export function calculatePower(type, max, limit, percent) {
  if (type === 0) {
    return Math.pow(percent / 100, 2.8) * (max / 1000) * (limit / 1000);
  }
  return percent;
}
